import { getOfflineSnapshot } from "~/utils/offline-pos"

export default defineNuxtPlugin({
	name: "offline-auth-bootstrap",
	enforce: "pre",
	async setup() {
		if (navigator.onLine || window.location.pathname !== "/") return

		const branchId = localStorage.getItem("sv_pos_branch_id")
		const posId = localStorage.getItem("sv_pos_device_id")
		if (!branchId || !posId) return

		const snapshot = await getOfflineSnapshot(branchId, posId).catch(() => null)
		if (!snapshot?.auth?._id || !snapshot?.shift?.opening_time || snapshot.shift?.closing_time) return

		useState("auth:data", () => undefined).value = snapshot.auth
		useState("auth:loading", () => true).value = false
		useState("auth:lastRefreshedAt", () => undefined).value = new Date()
	},
})
